import { tableHeader } from '../utils/constant';

export default function TransactionHeader() {
    return (
        <div className='hidden xl:flex flex-row justify-between bg-[#121212] w-full px-[40px] lg:px-[180px] pt-[40px] pb-[16px]'>
            {tableHeader.map((col, index) => (
                <p
                    key={col.key}
                    className={`text-[#86888C] text-[16px] font-Inter-Regular font-medium uppercase ${
                        index === 1 || index === 2 ? 'basis-1/12' : index === 5 ? 'basis-3/12' : 'basis-2/12'
                    }`}
                >
                    {col.title}
                </p>
            ))}
        </div>
    )
}
